import { doc,setDoc, getDoc, collection, getDocs ,addDoc} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "./context/AuthContext";
import { db, auth } from "./firebase/config";
import loader from "./loading.gif"
import logo from "./logo-no-background.png"

const Quiz =  () => {
  let { currentUser, logout } = UserAuth();
  
  let navigate = useNavigate();
  const [questions, setQuestions] = React.useState([]);
  const [userData, setUserData] = useState(null);
  const [count, setCount] = useState(0);
  const [progress, setProgress] = useState(0)
  const [score, setScore] = useState(0);
  const [wrong, setWrong] = useState(0);
  const [totalAttempts, setTotalAttempts] = useState(0);
  const [accuracy, setAccuracy] = useState(0);
  const [newLevelScore, setNewLevelScore] = useState(0);
  const [newLevelAttempts, setNewLevelAttempts] = useState(0);
  const [quizEnd, setQuizEnd] = useState(false);
  const [level, setLevel] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [start, setStart] = useState(false);
  const [userName, setUserName] = useState("");
  const [schoolEmail, setSchoolEmail] = useState("");
  const [school, setSchool] = useState("");
  const [retakeReason, setRetakeReason] = useState("");
  const [languageOption, setLanguageOption] = useState("Simplified Chinese");
  const [heritageLearner, setHeritageLearner] = useState("No");
  const [noOfYearsInChinese, setNoOfYearsInChinese] = useState('');
  const [feildsError, setFeildsError] = useState(false);
  const [internetDisconnected, setInternetDisconnected] = useState(false);
  useEffect(() => {
    // setTimeout(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
        if (user) {
            const userEmail = user.email;
            const docRef = doc(db, 'users', user.uid);
            getDoc(docRef).then((docSnap) => {
                if (docSnap.exists()) {
                setUserData(docSnap.data());
                
                setLanguageOption(docSnap.data().languageOption);
                }
              })
              .catch( (error)=>{
                console.log(error)
              });
        } else {
            setUserData(null);
        }
    });
    return () => unsubscribe();
  // }, 2000);
}, []);
  const suggestRecommendations = (currenLevel) => {
    // for Heritage learner
    console.log(userData)
    if(userData && userData.heritageLearner === "Yes"){
      if(currenLevel==0){
        // Level H1 = CHIN2
        return "No Recommendation";
      }
      if(currenLevel==1){
        // Level H1 = CHIN2
        return "CHIN2";
      }
      if(currenLevel==2){
        // Level H2 = CHIN2
        return "CHIN2";
      }
      if(currenLevel==3){
        // Level H2 = CHIN51H
        return "CHIN51H";
      }
      if(currenLevel==4){
        // Level H2 = CHIN51H
        return "Level 4: CHIN51B (spring only) or CHIN55 (spring only)";
      }
      if(currenLevel==5){
        // Level H2 = CHIN51H
        return "CHIN111A";
      }
      if(currenLevel==6){
        return "CHIN111B";
      }
      if(currenLevel==7){
        return "CHIN12X";
      }
      if(currenLevel>=8){
        return "CHIN131 above";
      }
    }
    // for Non Heritage learner
    else
    if(userData && userData.heritageLearner === "No"){
      if(currenLevel==0){
        // Level H1 = CHIN2
        return "No Recommendation";
      }
      if(currenLevel==1){
        return "CHIN1A";
      }
      if(currenLevel==2){
        return "CHIN1B";
      }
      if(currenLevel==3){
        return "CHIN51A";
      }
      if(currenLevel==4){
        return "Level 4: CHIN51B (spring only) or CHIN55 (spring only)";
      }
      if(currenLevel==5){
        return "CHIN111A";
      }
      if(currenLevel==6){
        return "CHIN111B";
      }
      if(currenLevel==7){
        return "CHIN12X";
      }
      if(currenLevel>=8){
        return "CHIN131 above";
      }
    }
  } 
  const addScore = () => {
    if(level>8){
      setLevel(8)
    }
    let classRecommended = suggestRecommendations(level);
    console.log(classRecommended)
    setDoc(doc(db,'users',currentUser?.uid),{
      scores: [score],
      level:level >=8 ? 8 : level,
      classRecommended: classRecommended,
      scoreDate:new Date()
    },{ merge: true })
    .catch((error)=> error.message);
  }
  // finnaly send email to users email address about their scores
  const sendScoresEmail = () => {
    if(level>=8){
      setLevel(8)
    }
    let classRecommended = suggestRecommendations(level);
    console.log(classRecommended)
    const newMailRef = collection(db, "mails");
    let heritageNoteTemp='';
    if(userData.heritageLearner === "Yes"){
      heritageNoteTemp = '<p style="color:red;">Please note that if needed, a follow-up oral proficiency interview will be scheduled for you by a Chinese professor.</p>'
    }
      addDoc(newMailRef, {
        to:currentUser?.email+', Feng.Xiao@pomona.edu',
        message: {
          subject:"Quiz Results For "+userData.name,
          html:"<div style='text-align: center;max-width: 300px;background-color: #f2f2f2;margin: auto;border-radius: 8px;padding: 20px;border: 1px solid #ccc;'>"+
          "Score : <strong>"+score+"</strong><br>"+
          "Level : <strong>"+(level >=8 ? 8 : level)+"</strong><br>"+
          "Class Recommended  : <strong>"+classRecommended+"</strong><br>"+
          "<hr>User details <br><strong>Name: </strong>"+userData.name+" <br>"+
          "<strong>Email: </strong>"+userData.email+"<br>"+
          "<strong>School: </strong>"+userData.school+
          heritageNoteTemp+
          "</div>"
        }
      });
  }
  let handleLogout = () => {
    logout();
    navigate("/");
  };
  let handleSubmit =async (answer,answerValue) => {
    const userActivityCollection = collection(db,`users/${currentUser.uid}/userActivity`);
    let correctAnswer = questions[count]?.Answers[questions[count]?.correctAnswer];
    let question = questions[count]?.Question;
    // let activityObj = {
    //   whatQuestion:question,
    //   whatAnswered:answerValue,
    //   correctAnswer: correctAnswer,
    //   marked:"Correct"
    // }
    setTimeout(function(){
      setProgress(parseInt(count+1/questions.length));
      setTotalAttempts(totalAttempts+1)
      setNewLevelAttempts(newLevelAttempts+1)
      if (questions[count]?.correctAnswer === answer) {
        setScore(score + 1);
        setNewLevelScore(newLevelScore+1);
        // adding activity
        addDoc(userActivityCollection, {
          whatQuestion:question,
          whatAnswered:answerValue,
          whatAnsweredIndex:answer,
          correctAnswer: correctAnswer,
          correctAnswerIndex: questions[count]?.correctAnswer,
          marked:"Correct",
          activityDate:new Date()
        });
      } else {
        setWrong(wrong+1)
        setScore(score);
        setNewLevelScore(newLevelScore);
        // adding activity
        addDoc(userActivityCollection, {
          whatQuestion:question,
          whatAnswered:answerValue,
          whatAnsweredIndex:answer,
          correctAnswer: correctAnswer,
          correctAnswerIndex: questions[count]?.correctAnswer,
          marked:"Wrong",
          activityDate:new Date()
        });
      }
      if (count + 1 < questions.length) {
        setCount(count + 1);
      } else {
        console.log(count+" / "+questions.length)
        setCount(0);
      }
      setAccuracy(parseInt(newLevelScore == 0 || newLevelAttempts ==0 ? 0 : (newLevelScore / newLevelAttempts) * 100))
    },200)
  };

  useEffect(() => {
    if(quizEnd) {
      addScore();
      sendScoresEmail();
      const usersRef = doc(db, "users", currentUser?.uid);
      setDoc(usersRef,{
          testTaken:true,
          reqestSubmitted:false
        } , { merge: true });
      navigate("/result", { state: { score, level: level>=8 ? 8 : level } });
      setLevel(0);
      setCount(0);
      return;
    }
    if(score <= 5 && score >= 0 && totalAttempts<=10 ){
      setLevel(1);
      return;
    }
    if(score >= 6 && score <= 15 && totalAttempts<=20 ){
      setLevel(2)
      return;
    }
    if(score >= 16 && score <= 25 && totalAttempts <=30 ){
      setLevel(3)
      return;
    }
    if(score >= 26 && score <= 35 && totalAttempts <=40 ){
      setLevel(4)
      return;
    }
    if(score >= 36 && score <= 45 && totalAttempts <=50 ){
      setLevel(5)
      return;
    }
    if(score >= 46 && score <= 55 && totalAttempts <=60 ){
      setLevel(6)
      return;
    }
    if(score >= 56 && score <= 65 && totalAttempts <=70 ){
      setLevel(7)
      return;
    }
    if(score >= 66 && score <= 70 && totalAttempts <=70 ){
      setLevel(8)
      return;
    }
    else
    setQuizEnd(true)
  },[quizEnd, score, accuracy, newLevelAttempts])

  useEffect(() => {
        const collectionsRef = collection(db,`questions/updatedLevel${level !== undefined && level!==0 ? level : 1}/${languageOption=="Traditional Chinese" ? "traditionalQuestions" : "simplifiedQuestions"}`);
        getDocs(collectionsRef).then((docSnap)=> { 
          const tmpQuestions = docSnap.docs.map((d)=> d.data());
          setQuestions(tmpQuestions);
        }).catch((e) => console.log(e.message)).finally(() => setLoading(false));
  },[level, languageOption]);

  useEffect(() => {
    if (isLoading) return;
    
    window.addEventListener("offline", function() {
      localStorage.setItem("wasDisconnected", true);
      setInternetDisconnected(true);
        console.log("Disconnected...so sad!!!")
    })
    window.addEventListener("online", function() {
      localStorage.setItem("connected", true);
    })
    let id;
    if(start)
      id = setTimeout(() => setSeconds((prevSec) => prevSec + 1), 1000);

    // console.log(seconds);
    if(seconds >= 1800) {
      setQuizEnd(true);
      // navigate("/result", { state: { score, level: level } });
      return;
    }

    if (count + 1 > questions?.length && count !== 0) 
      handleSubmit();

    return () => clearTimeout(id);
  }, [seconds, isLoading, start]);


  const shuffleArray = (array)  => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
  }
  function languageChangeHandler(evt) {
    setLanguageOption(evt.target.value);
  }
  function heritageChangeHandler(evt){
    console.log(evt.target.value)
  }
  function addDetailsHandler(){
    if (userName.length>=1 && schoolEmail.length>=3 && school.length>=1 && noOfYearsInChinese>=0) {
      setFeildsError(false);

      setDoc(doc(db,'users',currentUser?.uid),{
        name:userName,
        schoolEmail:schoolEmail,
        school:school,
        languageOption:languageOption,
        heritageLearner:heritageLearner,
        noOfYearsInChinese:noOfYearsInChinese,
        isAnswered:true,
      },{ merge: true }).then((docSnap) => {
        window.location.reload();
      }).catch((error)=> error.message) 
    }
    else{
      setFeildsError(true);
    }
  }
  const submitRetakeRequest =async ()=> {
    const approvalRequestRef = collection(db, "approvalRequests");
    const usersRef = doc(db, "users", currentUser?.uid);

    await setDoc(usersRef,{
      reqestSubmitted:true, 
      retakeRequest:"In Progress"
    } , { merge: true });
    
    addDoc(approvalRequestRef, {
      to: 'captest2023@gmail.com, feng.xiao@pomona.edu',
      message: {
        subject:"Quiz Retake Approval Request From "+userData.email,
        html:"<center>"+
          '<p><strong>Retake Reason: </strong><br><span style="font-style:italic;">"'+retakeReason+'"</span></p>'+
          "<a style='font-weight:bold;' href='https://adaptive-chinese-test.web.app/approve-retake/"+currentUser?.uid+"'>Click here to approve or reject quiz retake request</a><br>"+
          "<a style='font-weight:bold;' href='https://adaptive-chinese-test.web.app/admin'>Click here to export results to excell.</a>"+
        "</center>"
      }
    }).then((docSnap) => {
      alert("Retake request has been sent.");
      window.location.reload();
    }).catch((error)=> error.message);
  }
  const restartQuiz = async () => {
    setInternetDisconnected(false);
    if(localStorage.getItem("wasDisconnected")=="true"){
      localStorage.setItem("wasDisconnected", false);
    }
    const usersRef = doc(db, "users", currentUser?.uid);
    await setDoc(usersRef,{
        testTaken:false
      } , { merge: true });
      window.location.reload();
  }
  return (
  <div className="wrapper position-relative">
    <div style={internetDisconnected && start && userData.testTaken!==true  ? {display:"block"} : {display:"none"}} id="myModal" className="modal">
      <div className="modal-content">
        {/* <span className="close">&times;</span> */}
        <p>Internet disconnected, Please Restart the quiz once connected back.</p>
        <button className="theme-btn" onClick={restartQuiz}>Restart Quiz</button>
      </div>
    </div>
    <div className="header">
      <a className="logo" href={void(0)}>
        {/* <img src={logo} alt="" /> */}
        Adaptive Chinese Placement Test
      </a>
      <div className="right-content">
        <a href="#" onClick={() => navigate("/about")}>About</a>
        <a href="#" onClick={() => handleLogout()}>Logout</a>
      </div>
    </div>
    <div className="container">
    <div className="multisteps_form position-relative overflow-hidden" id="wizard">
      {userData && userData.isAnswered ? (
          start && userData.testTaken!==true ? (<div>
            <div className="row">
              <div className="col-md-4 ">
                  <div className="logo_area ms-3 pt-3">
                    <a onClick={() => handleLogout()}>
                        <img src="assets/images/logo/logo.png" alt="image_not_found"/>
                        {currentUser?.email}
                    </a>
                  </div>
                  <div className="scores-panel">
                    <p>Previous Scores: {userData?.scores?.join(', ')}</p>
                    <div className="level-holder">
                        <span>Correct: {score}</span>
                        <span>Wrong: {wrong}</span>
                        <span>Accuracy: {accuracy}%</span>
                    </div>
                    <div className="score-holder">
                      <span>Total Score: {score}</span>
                      <span>Total attempts: {totalAttempts}</span>
                      
                    </div>
                    {/* <div className="score-holder" style={{width:"355px"}}>
                      <span>New Level attempts: {newLevelAttempts}</span>
                      <span>New Level Score: {newLevelScore}</span>
                    </div> */}
                  </div>
              </div>
              <div className="col-md-4 d-none d-md-block">
                  <div className="form_header_content text-center pt-4">
                    <h2>Welcome to the Adaptive Chinese Placement Test</h2>
                  </div>
              </div>
              <div className="col-md-4 float-end pt-3">
                  <div className="count_box overflow-hidden rounded-pill d-flex me-3">
                    <div className="count_clock ps-2">
                        <img src="assets/images/counter/clock.png" alt="image_not_found"/>
                    </div>
                    <div className="count_title px-1">
                        <span>Remaining Time</span>
                    </div>
                    <div className="count_number rounded-pill bg-white overflow-hidden me-2 text-center countdown_timer" data-countdown="2022/10/24">
                        <h3>{new Date((1800 - seconds) * 1000).toISOString().substr(14,5) }s</h3>
                    </div>
                    
                  </div>
                  <p style={{marginTop:"30px", marginBottom:"0"}}>Language: <strong>{userData.languageOption}</strong></p>
                  <span style={{fontSize: "16px",fontWeight: "700"}}>Current level: {level}</span>
              </div>
            </div>
            <div className="multisteps_form_panel step">
              {start && (
              <div className="progress rounded-pill">
                <div className="progress-bar" role="progressbar" style={{width: `${progress}%` }} aria-valuenow={(count + 1)} aria-valuemin="0" aria-valuemax={questions.length}>{progress}%</div>
              </div>
              )}
            
              <span className="question_number text-uppercase mb-3 text-center"> {!start && "Click start"}</span>
              <h1 className="question_title px-5 animate__animated animate__fadeInRight ">
              {start && questions[count]?.Question}
              </h1>
              <div className="form_items">
                <ul className="list-unstyled p-0">
                {start && questions[count]?.Answers?.map((answer,index) => (
                  // style={questions[count]?.correctAnswer == index ? {backgroundColor:'green'} : {backgroundColor:'yellow'}}
                  userData && userData.email == "junitahir9@gmail.com" ||  userData.email == "fxiao81@gmail.com" ?
                  (
                  <li style={questions[count]?.correctAnswer == index ? {backgroundColor:'green'} : {backgroundColor:'yellow'}} key={answer} id={answer.Question} onClick={() => handleSubmit(index)} className="step_1 ps-5 rounded-pill animate__animated ">
                      {index+1}:
                      <input type="radio" id="opt_1" name="stp_1_select_option" value={answer}/>
                      <label htmlFor="opt_1">{answer}</label>
                  </li>
                  )
                  :
                  (<li key={answer} id={answer.Question} onClick={() => handleSubmit(index, answer)} className="step_1 ps-5 rounded-pill animate__animated ">
                    {index+1}:
                    <input type="radio" id="opt_1" name="stp_1_select_option" value={answer}/>
                    <label htmlFor="opt_1">{answer}</label>
                  </li>)
                  ))}
                </ul>
              </div>
            </div>
          </div>
          ) : (
            userData.testTaken ? (
              userData.reqestSubmitted===true ? (
                <center>
                  <h2 style={{textAlign: 'center',margin: '25px auto',maxWidth: '651px',fontSize: '22px',paddingTop: '30px'}}>Your Quiz Retake Request Submitted, You will get an email about your request soon.</h2>
                  {userData && (userData.rejectMessage && (<p>Message: <span style={{fontStyle:"italic"}}>{userData.rejectMessage}</span></p>))}
                  {userData && (<p>Current Status: <span style={{backgroundColor: "#4f9de2",padding: "5px",borderRadius: "5px",color: "white"}}>{userData.retakeRequest}</span></p>)}
                </center>
              ) : (
                <center>
                  <h2 style={{textAlign: 'center',marginTop: '25px',maxWidth: '651px',margin: 'auto',fontSize: '22px',paddingTop: '30px'}}>Please Enter The Reason Below For Retaking Quiz.</h2>
                  <p style={{marginTop:'10px',maxWidth: '600px'}}>After sending retake request, you have to wait for approval, once it's approved you will get an email and you can retake quiz again.</p>
                  <textarea style={{minWidth: '410px'}} name="retakeReason" id="" value={retakeReason} onChange={(event) => setRetakeReason(event.target.value)} cols="30" rows="10"></textarea><br/>
                  <button className="theme-btn" onClick={() => submitRetakeRequest()}>Submit Request</button>
                </center>
              )
            ) : (
              <div className="guidlines" style={{padding: "12px 30px"}}>
                <h1 className="text-center">Instructions before starting the quiz.</h1>
                <p><strong>Preparation</strong>: Make sure you have a stable internet connection and a quiet space for the duration of the test. This test is designed to evaluate your Chinese language ability, so it's important that you take it in a setting where you can focus without interruptions.</p>
                <p><strong>Access</strong>: The test can be found at <a href="https://adaptive-chinese-test.web.app">https://adaptive-chinese-test.web.app</a></p>
                <p><strong>Log In</strong>: Use your college credentials to sign up for an account. If you encounter any issues during the login process, please contact the Chinese language department.</p>
                <p>Answer the Questions: The test consists of several stages, each containing a variety of questions. These may include listening comprehension, reading comprehension, grammar, and vocabulary. Answer each question to the best of your ability.</p>
                <p>Adaptive Difficulty: The test is adaptive, meaning the difficulty of the questions will adjust based on your performance. Don't be discouraged if you find the questions increasingly difficult; this is a sign that you are doing well.</p>
                <p>I Don't Know Option: If you encounter a question that you can't answer, you can click on the "我不知道" button. Use this button sparingly, as it is better to try to work out an answer if you can.</p>
                <p><strong>Time Limit</strong>: Remember, the test is 30 minutes long. Try to pace yourself so that you have enough time to attempt each question. Don't spend too much time on any single question. The time remaining will be displayed on your screen.</p>
                <p><strong>No Cheating</strong>: Remember, the purpose of this test is to accurately assess your Chinese language ability and place you in a class that suits your level. Using outside resources or seeking help from others will not benefit you in the long term.</p>
                <p><strong>Submit</strong>: After answering all the questions or when the time limit is reached, click on the 'Submit' button to finish the test. Make sure you are ready to submit before clicking the button; you will not be able to return to the test after you have submitted it.</p>
                <p><strong>Post-Test</strong>: You will receive your placement results immediately after taking the test. The result will be sent to your registered email address. You will be placed in the appropriate class based on your performance.</p>
                <p>Remember, the goal of this test is to help you learn and grow in your understanding and usage of the Chinese language. Good luck!</p>
                <center>
                  {!start && <button className="theme-btn" onClick={() => setStart(true)}>Start</button>}
                </center>
              </div>
            )
            
          )
        ) : (
          userData ? (<><div className="row">
          <div className="col-md-12">
            <div className="form_header_content text-center pt-4">
                <h2>Enter Your Information to Proceed to the Quiz</h2>
                <div className="auth-form">
                <input className="my-input"
                  type="text"
                  placeholder="Name"
                  value={userName}
                  onChange={(event) => setUserName(event.target.value)}
                  />
                <input 
                className="my-input"
                  type="email"
                  placeholder="School Email"
                  value={schoolEmail}
                  onChange={(event) => setSchoolEmail(event.target.value)}
                />
                <input className="my-input"
                  type="text"
                  placeholder="School"
                  value={school}
                  onChange={(event) => setSchool(event.target.value)}
                />
                <select onChange={languageChangeHandler} className="my-input" name="" id="">
                    <option value="">Select Language</option>
                    <option value="Simplified Chinese">Simplified Chinese</option>
                    <option value="Traditional Chinese">Traditional Chinese</option>
                </select>
                
                <div className="radio-container">
                <p style={{marginBottom:0,marginRight:"16px"}}><strong>Are You a Heritage Learner?</strong></p>
                    <div className="heritage-radios">
                      <span>
                        <label htmlFor="heritageLearnerYes">Yes</label>
                        <input onChange={heritageChangeHandler} type="radio" id="heritageLearnerYes" name="heritageLearner" value="Yes"/>
                      </span>
                      <span>
                        <label htmlFor="heritageLearnerNo">No</label>
                        <input onChange={heritageChangeHandler} type="radio" id="heritageLearnerNo" name="heritageLearner" value="No"/>
                      </span>
                    </div>
                </div>
                <p style={{marginBottom: "0"}}>Number of Years Studying Chinese</p>
                <input value={noOfYearsInChinese}
                onChange={(event) => setNoOfYearsInChinese(event.target.value)}
                className="my-input" type="number" placeholder="No of years studying chinese"
                min="0"/>
                <p style={{color:"red"}}>{feildsError && "Please enter all details to proceed."}</p>
                <button onClick={addDetailsHandler} className="theme-btn">Submit</button>
            </div>
            </div>
          </div>
          </div></>) : (
            <div className="loading">
              <center><img style={{width: "100%",height: "38rem"}} src={loader} alt="" className="image-fluid" /></center>
            </div>
          )
          // render question form if initial questions not answered
      )}
      </div>
    </div>
  </div>
  );
};

export default Quiz;